import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AuthProvider } from "./auth";
import ErrorBoundary from "./components/ErrorBoundary";
import "./index.css";

// デプロイ直後、古いタブが存在しないチャンクを読もうとして真っ白になるのを自動回復。
// Vite が動的import失敗時に投げる vite:preloadError を捕まえ、一度だけ再読み込みする。
window.addEventListener("vite:preloadError", () => {
  try {
    const last = Number(sessionStorage.getItem("lb_reload_ts") || 0);
    if (Date.now() - last > 10000) { sessionStorage.setItem("lb_reload_ts", String(Date.now())); window.location.reload(); }
  } catch { window.location.reload(); }
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);

// PWA: Service Worker を登録（Push / 通知クリック遷移用）。HTTPS/localhost のみ有効。
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => { /* 登録失敗は致命的でない */ });
  });
}
